export default __webpack_public_path__ + "resources/icons/n122-41bb.png";